import AdvanceTable from "components/common/advance-table/AdvanceTable";
import CardDropdown from "components/common/CardDropdown";
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import { Dropdown } from "react-bootstrap";
import TablePaginationFooter from "components/common/TablePaginationFooter";

export default function RoutesTable({
  routes,
  onEdit,
  setShowDeleteModal,
  setRouteToDelete,
  page,
  pageSize,
  totalPages,
  totalElements,
  setPage,
  setPageSize,
}) {
  const formatText = (text) => `${text.slice(0, 25)}...`;

  const confirmDelete = (id) => {
    setRouteToDelete(id);
    setShowDeleteModal(true);
  };

  const columns = [
    {
      accessorKey: "path",
      header: "Path",
      cell: ({ getValue }) => (
        <h6
          className="mb-0 text-900 fs-10 text-truncate d-inline-block"
          style={{ maxWidth: 300 }}
          title={getValue()}
        >
          {getValue()}
        </h6>
      ),
      meta: {
        headerProps: { className: "text-900" },
      },
    },
    {
      accessorKey: "description",
      header: "Description",
      cell: ({ getValue }) => {
        const text = getValue() || "No decription provided";
        const displayText = text.length > 25 ? formatText(text) : text;
        return (
          <span
            className="text-500 d-inline-block"
            style={{ fontSize: "0.75rem", fontWeight: 500, lineHeight: 1.4 }}
          >
            {displayText}
          </span>
        );
      },
      meta: {
        headerProps: { className: "text-900" },
        cellProps: { className: "align-middle" },
      },
    },
    {
      accessorKey: "active",
      header: "Status",
      cell: ({ getValue }) => {
        const value = getValue();
        const style = {
          backgroundColor: value ? "#e8f7e3" : "#fbe9e7",
          color: value ? "#2e7d32" : "#c62828",
          padding: "2px 6px",
          borderRadius: "4px",
          fontSize: "0.7rem",
          lineHeight: 1.2,
          border: value ? "1px solid #d5ebd0" : "1px solid #f5c6cb",
          cursor: "default",
          fontWeight: 600,
          display: "inline-block",
          whiteSpace: "nowrap",
          verticalAlign: "middle",
        };
        const content = value === true ? "ACTIVE" : "DISABLED";
        return <span style={style}>{content}</span>;
      },
      meta: {
        headerProps: { className: "text-900 text-center" },
        cellProps: { className: "text-center" },
      },
    },
    {
      accessorKey: "priority",
      header: "Priority",
      meta: {
        headerProps: { className: "text-900 text-center" },
        cellProps: { className: "text-center" },
      },
    },
    {
      accessorKey: "scopeRules",
      header: "Rules",
      cell: ({ getValue }) => {
        const rules = getValue() || [];
        return rules.length;
      },
      meta: {
        headerProps: { className: "text-900 text-center" },
        cellProps: { className: "text-center" },
      },
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const item = row.original;
        return (
          <CardDropdown drop="start">
            <div className="py-2">
              <Dropdown.Item onClick={() => onEdit(item)}>
                View/edit
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => confirmDelete(item.id)}
                className="text-danger"
              >
                Delete
              </Dropdown.Item>
            </div>
          </CardDropdown>
        );
      },
      meta: {
        headerProps: { className: "text-900 text-center" },
        cellProps: { className: "text-center" },
      },
    },
  ];

  const table = useAdvanceTable({
    data: routes,
    columns,
    sortable: true,
    pagination: true,
    perPage: pageSize,
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <AdvanceTable
          headerClassName="bg-300 text-nowrap align-middle"
          rowClassName="align-middle white-space-nowrap"
          tableProps={{
            bordered: true,
            striped: true,
            className: "fs-10 mb-0 overflow-hidden",
          }}
        />
        <div className="mt-3">
          <TablePaginationFooter
            page={page}
            totalPages={totalPages}
            totalElements={totalElements}
            onPrev={page > 0 && totalElements > 0 ? () => setPage(page - 1) : undefined}
            onNext={
              page < totalPages - 1 && totalElements > 0
                ? () => setPage(page + 1)
                : undefined
            }
            pageSize={pageSize}
            onPageSizeChange={(size) => {
              setPageSize(size);
              setPage(0);
            }}
            pageSizeOptions={[10, 20, 30, 50, 100]}
          />
        </div>
      </AdvanceTableProvider>
    </>
  );
}
